import { Action } from "../createDataContext";

export class WikiState {
  wikis: Wiki[] = [];
  listedWikis: Wiki[] = [];
}

export interface Wiki {
  wikiID: number;
  choice: Translation;
  infos: WikiInfo[];
}

export type WikiInfo = {
  imageUrl: string;
  title: Translation;
  subtitle: Translation;
};

export type Translation = {
  en: string;
  hu: string;
};

export enum WikiActionType {
  LOAD_WIKIS = "LOAD_WIKIS",
  FIND_WIKIS = "FIND_WIKIS",
}

export type WikiActions = LoadWikisAction | FindWikisAction;

export interface LoadWikisAction extends Action {
  type: WikiActionType.LOAD_WIKIS;
  payload: {
    wikis: Wiki[];
  };
}

export interface FindWikisAction extends Action {
  type: WikiActionType.FIND_WIKIS;
  payload: {
    wikis: Wiki[];
  };
}
